import { memo, useEffect, useState, useRef } from 'react';
import { useLottie, useImageLoading } from '@diezhi/yesio';
import lottieJson from './lottieLoading/data.json';
import styles from './style.module.scss';

const PageLoading = ({
  preLoadImages,
}) => {
  const percentRef = useRef(0);
  const processRef = useRef(0);
  const lottieRef = useRef();
  const [loadPercent, setLoadPercent] = useState(0);
  useLottie(lottieRef, lottieJson);

  const { process } = useImageLoading(preLoadImages);
  useEffect(() => {
    processRef.current = process;
  }, [process]);

  // 百分比数字跳动
  useEffect(() => {
    const tick = () => {
      if (percentRef.current < 100) {
        const val = Math.min(processRef.current, percentRef.current + 2);
        setLoadPercent(val);
        percentRef.current = val;
        requestAnimationFrame(tick);
      }
    };

    tick();
  }, []);

  // 防止ios safari中底栏遮挡页面
  useEffect(() => {
    const convertStyle = () => {
      document.body.style.setProperty('height', `${window.innerHeight}px`);
    };

    window.addEventListener('resize', convertStyle);
    window.addEventListener('DOMContentLoaded', convertStyle);

    return () => {
      window.removeEventListener('resize', convertStyle);
      window.removeEventListener('DOMContentLoaded', convertStyle);
    };
  }, []);

  return (
    <div className={`${styles.pageLoading} ${process === 100 && loadPercent === 100 ? styles.fadeOut : ''}`}>
      <div className={styles.loadingContent}>
        <div className={styles.lottieContainer} ref={lottieRef} />
        <div className={styles.evolImage} />
        <div className={styles.percent}>
          {loadPercent}<span>%</span>
        </div>
      </div>
    </div>
  );
};

PageLoading.defaultProps = {
  preLoadImages: [],
};

export default memo(PageLoading);
